import { useContext } from 'react'
import { CartContext } from '../Context/cart'

export const useCart = () => {
  const context = useContext(CartContext)

  if (context === undefined) {
    throw new Error('useCart debe ser usado con el CartProvider')
  }

  return context
}
